/** «186/4»: название пантона и версия через «/»; без версии — только название. */
export function formatPantoneLabel(name: string, version?: number | null) {
    return version == null ? name : `${name}/${version}`
}
